import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSession } from "../store/session";
import { Button, Field, Input } from "../components/Controls";
import { BrandMark } from "../components/BrandMark";
import { errorMessage } from "../api/client";

export default function LoginPage() {
  const { session, login } = useSession();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (session) return <Navigate to={session.operator.role === "admin" ? "/piezas" : "/registrar"} replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!username.trim() || !/^\d{4,8}$/.test(pin)) {
      setError("Ingresar usuario y un PIN de 4 a 8 dígitos.");
      return;
    }
    setBusy(true);
    try {
      const op = await login(username.trim().toLowerCase(), pin);
      navigate(op.role === "admin" ? "/piezas" : "/registrar", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr,1fr]">
      <div className="on-dark relative hidden overflow-hidden bg-graphite p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <svg viewBox="0 0 400 400" className="reticle-draw pointer-events-none absolute -right-24 top-1/2 h-[560px] w-[560px] -translate-y-1/2 text-mark/30" fill="none" aria-hidden="true">
          <path d="M40 120V40h80M280 40h80v80M360 280v80h-80M120 360H40v-80" stroke="currentColor" strokeWidth="3" />
          <path d="M200 150v-30M200 280v-30M150 200h-30M280 200h-30" stroke="currentColor" strokeWidth="2" />
          <circle cx="200" cy="200" r="48" stroke="currentColor" strokeWidth="2" />
        </svg>
        <div className="relative flex items-center gap-3">
          <BrandMark className="h-9 w-9" />
          <span className="font-display text-xl font-bold">Ally Quality</span>
        </div>
        <div className="relative">
          <h1 className="font-display text-5xl font-extrabold leading-[0.92] xl:text-7xl">Inspección<br />de piezas</h1>
          <p className="mt-6 max-w-md text-lg text-slate-300">Panel del supervisor: piezas, fotos de entrenamiento, inspecciones en vivo e indicadores.</p>
        </div>
        <p className="relative text-sm text-slate-400">Control de calidad visual con inteligencia artificial</p>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 animate-rise" data-testid="login-form">
          <div>
            <div className="mb-8 flex items-center gap-2 lg:hidden"><BrandMark tone="light" className="h-7 w-7" /><span className="font-display text-lg font-bold">Ally Quality</span></div>
            <h2 className="font-display text-4xl font-bold">Entrar</h2>
            <p className="mt-1 text-sm text-slate-500">Usuario y PIN asignados por el supervisor.</p>
          </div>
          <Field label="Usuario">
            <Input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoCapitalize="none" className="h-12" data-testid="login-username-input" />
          </Field>
          <Field label="PIN">
            <Input type="password" inputMode="numeric" pattern="\d*" maxLength={8} value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))} autoComplete="current-password" className="h-12 font-mono tracking-[0.4em]" data-testid="login-pin-input" />
          </Field>
          <Button type="submit" className="h-12 w-full text-base" loading={busy} data-testid="login-submit-button">Entrar</Button>
          {error && <p className="text-sm font-medium text-ng" data-testid="login-error">{error}</p>}
        </form>
      </div>
    </div>
  );
}
